<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
            <el-form-item label="参数值" prop="name">
                <el-input v-model="form.name" placeholder="请输入参数值"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="handleConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { addItem, editItem } from "@/api/product/filter";
export default {
    data() {
        return {
            title: "添加参数",
            visible: false,
            form: {
                name: "",
            },
            rules: {
                name: [{ required: true, message: "请输入参数值" }],
            },
        };
    },
    methods: {
        open(row, filter_uuid) {
            this.visible = true;
            if (row) {
                this.title = "编辑参数";
                this.form = { name: row.name, uuid: row.uuid };
            } else {
                this.title = "添加参数";
                this.form = { name: "", filter_uuid };
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.form.uuid) {
                    editItem(this.form).then(({ code, error }) => {
                        if (code == 200) {
                            this.$message.success("编辑成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    addItem(this.form).then(({ code, error }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
